import { createContext } from "react";

export const UserContext = createContext(null);
export const LocaliteContext = createContext(null);
export const ElementContext = createContext(null);